import { createSlice, PayloadAction } from '@reduxjs/toolkit'

type SliceState = {
  isAgentUnavailable: boolean
}

const initialState: SliceState = { isAgentUnavailable: false }

export const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    setIsAgentUnavailable: (state, action: PayloadAction<boolean>) => {
      state.isAgentUnavailable = action.payload
    }
  }
})

export const { setIsAgentUnavailable } = appSlice.actions

export default appSlice.reducer
